<!-- Main Page and Parent component for all pages 
 Copy right - © 2024 tecera gmbh
 -->
<script>
    import { Router, Route } from "svelte-routing";
    import Login from "./pages/Login.svelte";
    import Register from "./pages/Register.svelte";
    import Reset from "./pages/Reset.svelte";
    import TrinkBrunnen from "./pages/TrinkBrunnen.svelte";
    import MontageUebersicht from "./pages/MontageUebersicht.svelte";
    import Verwaltung from "./pages/Verwaltung.svelte";
    import NotFound from "./pages/NotFound.svelte";
    import DevPage from "./pages/DevPage.svelte";
    import Toast from "./components/Toast.svelte";
    import {DEBUG} from "./config.js";
    import Dashboard from "./pages/Dashboard.svelte";
    import DeviceVerwaltung from "./pages/DeviceVerwaltung.svelte";
</script>

<Toast />

<Router>
    <Route path="/" component={Login} />
    <Route path="/register" component={Register} />
    <Route path="/reset_password" component={Reset} />

    <Route path="/dashboard" component={Dashboard} />
    <Route path="/trinkbrunnen" component={TrinkBrunnen} />

    <Route path="/user_management" component={Verwaltung} />
    <Route path="/device_management" component={DeviceVerwaltung} />
    <!-- <Route path="/montage_uebersicht" component={MontageUebersicht} /> -->

    {#if DEBUG}
    <Route path="/dev" component={DevPage} />
    {/if}
    <Route path="/*" component={NotFound} />
</Router>

